/**
 * FRFind — поиск лица, когда обычный проход его не нашёл.
 *
 * ЗАЧЕМ ЭТО ОТДЕЛЬНЫМ СЛОЕМ. Детектор MediaPipe приводит вход к своему
 * фиксированному размеру, поэтому «лицо видно» и «лицо найдётся» — разные
 * вещи: решает не размер снимка в пикселях, а ДОЛЯ кадра, которую лицо
 * занимает. На снимке документа, на общем плане и на групповом фото лицо
 * занимает 3–6% ширины, и увеличение всего кадра не помогает НИЧЕМ — после
 * приведения к входному размеру доля та же самая.
 *
 * Помогает только КАДРИРОВАНИЕ: лицо в окне, которое втрое меньше кадра,
 * становится втрое крупнее относительно входа детектора. Отсюда лестница:
 *
 *   1. весь кадр                        — 1 проба, обычный путь;
 *   2. четыре поворота на 90°           — 3 пробы, снимок «боком» без EXIF;
 *   3. сетка окон 1/2 кадра с нахлёстом — 9 проб;
 *   4. сетка окон 1/3 кадра с нахлёстом — 25 проб, только если кадр крупный;
 *   5. окно вокруг точки, куда ткнул человек — когда автоматика сдалась.
 *
 * Ступени 2–4 запускаются ТОЛЬКО после провала первой: на обычном портрете
 * они не стоят ничего, потому что не выполняются. Полная лестница на кадре
 * 1100 px — примерно 1.5–2.5 с, и именно поэтому она сопровождается
 * прогрессом, а не тишиной.
 *
 * Координаты лиц возвращаются в системе ИСХОДНОГО кадра (0..1), то есть
 * вызывающему всё равно, каким окном лицо было найдено.
 */
(function (root) {
    'use strict';

    var MIN_TILE_PX = 256;    // ниже этого детектору нечего смотреть

    /** Холст-черновик переиспользуется: 34 новых холста на снимок — это мусор
     *  для сборщика ровно там, где мы боремся за секунды. */
    var _tile = null, _tctx = null;
    function tileCanvas(w, h) {
        if (!_tile) { _tile = document.createElement('canvas'); _tctx = _tile.getContext('2d', { willReadFrequently: false }); }
        if (_tile.width !== w || _tile.height !== h) { _tile.width = w; _tile.height = h; }
        return _tile;
    }

    /**
     * Одна проба: вырезать окно `rect` (в пикселях исходника), увеличить до
     * рабочего размера и спросить детектор. Найденные точки переводятся
     * обратно в координаты исходника.
     *
     * @param {object} rect {x,y,w,h} в пикселях источника
     * @param {number} rot  0|90|180|270 — поворот окна перед пробой
     */
    async function probe(src, srcW, srcH, rect, rot) {
        var rw = Math.max(1, Math.round(rect.w)), rh = Math.max(1, Math.round(rect.h));
        // Увеличиваем окно до разумного размера: детектор работает по
        // содержимому, но слишком мелкий вход теряет и его.
        var k = Math.max(1, MIN_TILE_PX / Math.min(rw, rh));
        k = Math.min(k, 1024 / Math.max(rw, rh));
        if (!isFinite(k) || k <= 0) k = 1;
        var dw = Math.max(1, Math.round(rw * k)), dh = Math.max(1, Math.round(rh * k));
        var swap = (rot === 90 || rot === 270);
        var c = tileCanvas(swap ? dh : dw, swap ? dw : dh);
        var ctx = _tctx;
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.clearRect(0, 0, c.width, c.height);
        ctx.save();
        ctx.translate(c.width / 2, c.height / 2);
        if (rot) ctx.rotate(rot * Math.PI / 180);
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(src, rect.x, rect.y, rw, rh, -dw / 2, -dh / 2, dw, dh);
        ctx.restore();

        var faces = await root.FRLandmarks.detect(c, c.width, c.height, {});
        if (!faces.length) return [];

        // Обратный перевод. Точки приходят нормализованными к ОКНУ (и уже
        // повёрнутыми вместе с ним), поэтому сперва снимаем поворот, затем
        // переводим в доли исходного кадра.
        var inv = -(rot || 0) * Math.PI / 180;
        var ca = Math.cos(inv), sa = Math.sin(inv);
        var mapPt = function (p) {
            // из долей окна — в пиксели окна относительно его центра
            var px = (p.x - 0.5) * c.width, py = (p.y - 0.5) * c.height;
            var ux = px * ca - py * sa, uy = px * sa + py * ca;   // снять поворот
            return {
                x: (rect.x + rw / 2 + ux / k) / srcW,
                y: (rect.y + rh / 2 + uy / k) / srcH,
                z: p.z,
            };
        };
        for (var i = 0; i < faces.length; i++) {
            var f = faces[i];
            f.pts = f.pts.map(mapPt);
            var poly = function (pg) {
                if (!pg) return pg;
                return pg.map(function (q) {
                    var px = (q[0] - 0.5) * c.width, py = (q[1] - 0.5) * c.height;
                    var ux = px * ca - py * sa, uy = px * sa + py * ca;
                    return [(rect.x + rw / 2 + ux / k) / srcW, (rect.y + rh / 2 + uy / k) / srcH];
                });
            };
            f.oval = poly(f.oval); f.leftEye = poly(f.leftEye); f.rightEye = poly(f.rightEye);
            f.lips = poly(f.lips); f.mouthOpen = poly(f.mouthOpen);
            f.leftBrow = poly(f.leftBrow); f.rightBrow = poly(f.rightBrow);
            var minX = 1, minY = 1, maxX = 0, maxY = 0;
            for (var j = 0; j < f.pts.length; j++) {
                var p2 = f.pts[j];
                if (p2.x < minX) minX = p2.x; if (p2.y < minY) minY = p2.y;
                if (p2.x > maxX) maxX = p2.x; if (p2.y > maxY) maxY = p2.y;
            }
            f.box = { x: minX, y: minY, w: maxX - minX, h: maxY - minY };
            f.foundVia = rot ? ('rot' + rot) : 'tile';
        }
        return faces;
    }

    /** Пересечение по площади — для склейки одного лица, найденного двумя окнами. */
    function iou(a, b) {
        var x1 = Math.max(a.x, b.x), y1 = Math.max(a.y, b.y);
        var x2 = Math.min(a.x + a.w, b.x + b.w), y2 = Math.min(a.y + a.h, b.y + b.h);
        if (x2 <= x1 || y2 <= y1) return 0;
        var inter = (x2 - x1) * (y2 - y1);
        return inter / (a.w * a.h + b.w * b.h - inter);
    }

    /** Отсев дублей и заведомого мусора (окно вырезало половину лица). */
    function merge(into, found) {
        for (var i = 0; i < found.length; i++) {
            var f = found[i];
            // Лицо, вылезшее за границы кадра больше чем наполовину, — это
            // почти всегда обрывок на краю окна, а не лицо.
            if (f.box.x + f.box.w < 0.02 || f.box.x > 0.98 || f.box.y + f.box.h < 0.02 || f.box.y > 0.98) continue;
            var dup = false;
            for (var j = 0; j < into.length; j++) {
                if (iou(into[j].box, f.box) > 0.35) { dup = true; break; }
            }
            if (!dup) into.push(f);
        }
        return into;
    }

    /** Сетка окон с нахлёстом: доля кадра `size`, шаг `stride` от неё. */
    function grid(w, h, size, stride) {
        var out = [];
        var tw = w * size, th = h * size;
        var sx = tw * stride, sy = th * stride;
        for (var y = 0; y + th <= h + sy * 0.5; y += sy) {
            for (var x = 0; x + tw <= w + sx * 0.5; x += sx) {
                out.push({ x: Math.min(x, w - tw), y: Math.min(y, h - th), w: tw, h: th });
            }
        }
        return out;
    }

    /**
     * Полная лестница поиска.
     *
     * @param {object} o {onStep(done,total), signal, deep}
     * @returns {Promise<{faces:Array, via:string, tries:number}>}
     */
    async function search(src, w, h, o) {
        o = o || {};
        var tries = 0;
        var step = function (done, total) { try { o.onStep && o.onStep(done, total); } catch (_) { } };
        var stopped = function () { return !!(o.signal && o.signal.aborted); };

        // 1. Весь кадр — обычный путь, он же самый дешёвый.
        var faces = await root.FRLandmarks.detect(src, w, h, {});
        tries++;
        if (faces.length) return { faces: faces, via: 'full', tries: tries };
        if (stopped()) return { faces: [], via: 'stopped', tries: tries };

        // Дальше — только если попросили копать. Обычному портрету эта работа
        // не достаётся никогда.
        if (o.deep === false) return { faces: [], via: 'none', tries: tries };

        var full = { x: 0, y: 0, w: w, h: h };
        var plan = [];
        // 2. Повороты: снимок с телефона без EXIF, скан «боком».
        plan.push({ rect: full, rot: 90 }, { rect: full, rot: 270 }, { rect: full, rot: 180 });
        // 3. Половинки кадра.
        grid(w, h, 0.5, 0.5).forEach(function (r) { plan.push({ rect: r, rot: 0 }); });
        // 4. Трети — только когда есть что кадрировать: на 400-пиксельном
        //    кадре треть это 130 px, и увеличивать там уже нечего.
        if (Math.min(w, h) >= 600) {
            grid(w, h, 0.32, 0.55).forEach(function (r) { plan.push({ rect: r, rot: 0 }); });
        }

        for (var i = 0; i < plan.length; i++) {
            if (stopped()) return { faces: faces, via: 'stopped', tries: tries };
            step(i, plan.length);
            var got = await probe(src, w, h, plan[i].rect, plan[i].rot);
            tries++;
            if (got.length) {
                merge(faces, got);
                // Поворот кадра — свойство ВСЕГО снимка: нашли лицо боком,
                // значит и остальные лица там же, а сетка окон бессмысленна.
                if (plan[i].rot) return { faces: faces, via: 'rot' + plan[i].rot, tries: tries, rotated: plan[i].rot };
            }
            // Отдаём кадр браузеру: 34 синхронные пробы подряд вешают вкладку
            // и убивают ту самую полосу прогресса, ради которой это писалось.
            if ((i & 3) === 3) await new Promise(function (r) { setTimeout(r, 0); });
        }
        step(plan.length, plan.length);
        return { faces: faces, via: faces.length ? 'tiles' : 'none', tries: tries };
    }

    /**
     * Поиск вокруг точки, куда ткнул человек.
     *
     * Это последний рубеж и он же самый надёжный: человек ВИДИТ лицо и знает,
     * где оно. Пробуем несколько окон разного размера вокруг точки — от
     * четверти кадра до одной двенадцатой.
     */
    async function around(src, w, h, nx, ny, o) {
        o = o || {};
        var sizes = [0.5, 0.3, 0.18, 0.1];
        var tries = 0;
        for (var i = 0; i < sizes.length; i++) {
            var tw = w * sizes[i], th = h * sizes[i];
            var rect = {
                x: Math.max(0, Math.min(w - tw, nx * w - tw / 2)),
                y: Math.max(0, Math.min(h - th, ny * h - th / 2)),
                w: tw, h: th,
            };
            try { o.onStep && o.onStep(i, sizes.length); } catch (_) { }
            var got = await probe(src, w, h, rect, 0);
            tries++;
            if (got.length) {
                // Из нескольких — то, что ближе к точке нажатия: человек
                // указал на конкретное лицо, а не «куда-то сюда».
                got.sort(function (a, b) {
                    var da = Math.hypot(a.box.x + a.box.w / 2 - nx, a.box.y + a.box.h / 2 - ny);
                    var db = Math.hypot(b.box.x + b.box.w / 2 - nx, b.box.y + b.box.h / 2 - ny);
                    return da - db;
                });
                return { faces: got, via: 'point' + Math.round(sizes[i] * 100), tries: tries };
            }
            await new Promise(function (r) { setTimeout(r, 0); });
        }
        return { faces: [], via: 'none', tries: tries };
    }

    // grid/merge/iou — общие с видео (FRVideo.createFinder): сетка окон и склейка
    // одного лица, найденного двумя окнами, обязаны быть ОДНИМИ на фото и видео.
    root.FRFind = { search: search, around: around, probe: probe, grid: grid, merge: merge, iou: iou };
})(typeof window !== 'undefined' ? window : globalThis);
